module.exports = "images/our-secret-sauce_poster@2x.webp";